import React from "react";
import { withRouter } from "react-router-dom";
import ModalPopup from "../common/ModalPopup";
import TermsContent from "./TermsContent";

function TermsRouteModal({ history }) {
  return (
    <ModalPopup
      isOpen={true}
      toggle={() => history.goBack()}
      title="Terms & Conditions"
      footer={false}
      bodyHeight={true}
    >
      <TermsContent />
    </ModalPopup>
  );
}

export default withRouter(TermsRouteModal);
